import { ProfileOptions, UserInformation } from '@app-models/user.model';
import { createReducer, on } from '@ngrx/store';
import * as actions from '../../actions/index';

export interface ProfileState {
  user: UserInformation;
  profileOptions: ProfileOptions;
}

const initialState: ProfileState = {
  user: null,
  profileOptions: {
    maritalStatuses: [],
  },
};

const _profileReducer = createReducer(
  initialState,
  on(actions.setProfile, (state, { user }) => {
    return {
      ...state,
      user,
    };
  }),
  on(actions.clearProfile, (state) => {
    return {
      ...state,
      user: null,
      profileOptions: {
        maritalStatuses: [],
      },
    };
  }),
  on(actions.setOptionsProfile, (state, { maritalStatuses }) => {
    return {
      ...state,
      profileOptions: {
        maritalStatuses,
      },
    };
  })
);

export function profileReducer(state, action) {
  return _profileReducer(state, action);
}
